import { Stub } from '@direct-frontend/components';
import styles from './DashboardAlert.module.css';

export const DashboardAlertStub = () => (
    <div className={styles.infoBlockContainer}>
        <Stub borderRadius="14" width={380} height={154} />
    </div>
);
